import React from "react";
import firebase from "firebase";
import { LoginView } from "./LoginView";
//PrimeReact Components
import * as pr from "../../common/PrimeComponents";

export class LoginController extends React.Component {
  state = {
    loading: false,
    rememberMe: false,
    showPassword: false,
    showBusinesses: false,
    businessOptions: [],
    selectedBusiness: "",
    email: "",
    password: ""
  };

  handleSubmitFirebase = () => {
    this.setState({ loading: true }, () => {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.state.email, this.state.password)
        .then(() => {
          firebase.auth().currentUser.reload();
          firebase
            .auth()
            .currentUser.getIdToken(true)
            .then(idToken => {
              localStorage.setItem("firebaseIdToken", idToken);
              localStorage.setItem("rememberMe", this.state.rememberMe);

              this.handleSubmitBusiness();
            });
        })
        .catch(err => {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: err.message,
            life: 6000
          });
        });

      this.setState({ loading: false });
    });
  };

  handleSubmitBusiness = () => {
    this.setState({ loading: true }, async () => {
      let loginRequest = {};
      loginRequest.userEmail = this.state.email;

      let loginResponse = await this.props.viewModel.loginApiV1LoginListBusinesses(
        loginRequest
      );
      console.log(loginResponse);

      if (loginResponse.errorCode === 0) {
        if (Array.isArray(loginResponse.businessList)) {
          if (loginResponse.businessList.length === 1) {
            this.setState(
              {
                selectedBusiness: loginResponse.businessList[0].codeTag
              },
              () => {
                this.handleSubmitLogin();
              }
            );
          } else {
            let businessOptions = [];

            loginResponse.businessList.forEach(e => {
              businessOptions.push({ label: e.businessName, value: e.codeTag });
            });

            this.setState({
              showBusinesses: true,
              businessOptions: businessOptions
            });
          }
        } else {
          this.growl.show({
            severity: "warn",
            summary: "Warning",
            detail: "No businesses found",
            life: 3000
          });
        }
      } else {
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail:
            "An error occured retrieving the businesses, please refresh and try again",
          life: 3000
        });
      }

      this.setState({ loading: false });
    });
  };

  handleSubmitLogin = () => {
    this.setState({ loading: true }, async () => {
      let loginRequest = {};
      loginRequest.codeTag = this.state.selectedBusiness;
      loginRequest.userEmail = this.state.email;

      let loginResponse = await this.props.viewModel.loginApiV1Login(
        loginRequest
      );
      console.log(loginResponse);

      if (loginResponse.errorCode === 0) {
        localStorage.setItem("email", this.state.email);

        Object.entries(loginResponse).forEach(([key, value]) => {
          localStorage.setItem(key, value);
        });

        window.location.reload();
      } else {
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail:
            "User has been deleted or does not exist, please contact an administrator",
          life: 6000
        });
      }

      this.setState({ loading: false });
    });
  };

  handleKeyPress = e => {
    if (e.key === "Enter") {
      this.handleSubmitFirebase();
    }
  };

  onInputChange = e => {
    this.setState({ [e.target.id]: e.target.value });
  };

  onDropChange = e => {
    this.setState({ [e.id]: e.value });
  };

  onCheckboxChange = e => {
    this.setState({ [e.id]: e.checked });
  };

  toggleShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  render() {
    return (
      <React.Fragment>
        <pr.Growl ref={el => (this.growl = el)} position="topright"></pr.Growl>
        <LoginView
          loading={this.state.loading}
          rememberMe={this.state.rememberMe}
          showPassword={this.state.showPassword}
          showBusinesses={this.state.showBusinesses}
          businessOptions={this.state.businessOptions}
          selectedBusiness={this.state.selectedBusiness}
          email={this.state.email}
          password={this.state.password}
          handleSubmitFirebase={this.handleSubmitFirebase}
          handleSubmitLogin={this.handleSubmitLogin}
          handleKeyPress={this.handleKeyPress}
          onInputChange={this.onInputChange}
          onDropChange={this.onDropChange}
          onCheckboxChange={this.onCheckboxChange}
          toggleShowPassword={this.toggleShowPassword}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Login/LoginController.js